import { Component } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {LoginRequest} from "../models/login-request";
import {ToastrService} from "ngx-toastr";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../services/auth-service";
import {BaseResponse} from "../../../core/models/base-response";
import {Token} from "../models/token";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrl: './login.component.css',
    standalone: false
})
export class LoginComponent {
  guid = '';


  constructor(private route: ActivatedRoute) {
    this.guid = this.route.snapshot.params['guid'];
  }


}
